// TextAreaControl.tsx
import React, { useEffect, useState } from 'react';
import { Control } from '../ControlRenderer';
import { get, set } from '../utils/Utils'
import { FormControl, FormHelperText, TextareaAutosize, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FormModeType } from '@/components/FormDataProvider';
import { useValidation } from '@/components/ValidationProvider';

interface TextAreaControl extends Control {
  placeholder?: string;
}

interface TextAreaControlProps {
  control: Control;
  data: any;
  onDataChange: (newData: any) => void;
  mode: FormModeType;
}

const TextAreaControl: React.FC<TextAreaControlProps> = ({ control, data, onDataChange, mode }) => {
  const { errors, validateData, setDataContext } = useValidation();
  const theme = useTheme();
  const handleFieldChange = (fieldName: string, value: string) => {
    setSelectedValue(value);
    set(data, fieldName, value);
    onDataChange(data);
    validateData();
  };

  const textStyle: React.CSSProperties = {
  };

  if (control.horizontalAlignment === 'stretch') {
    textStyle.width = '100%';
  }

  if (control.horizontalAlignment === 'stretch') {
    textStyle.width = '100%';
  }

  if (control.minWidth) {
    textStyle.minWidth = control.minWidth;
  }

  const [selectedValue, setSelectedValue] = useState<any>(get(data, control.dataKey ?? '', '') ?? '');

  const errorMessage = errors && control.dataKey ? errors[control.dataKey] : undefined;

  const textAreaControl = control as TextAreaControl;

  useEffect(() => {
    setSelectedValue(get(data, control.dataKey ?? '', '') ?? '')
  }, [data, control.dataKey]);

  useEffect(() => {
    if (data) {
      setDataContext(data);
    }
  }, [data, setDataContext]);

  let currentMode = control.mode ? control.mode : mode;

  if (currentMode === 'label') {
    return (
      <Typography className='eform-labelmode'>
        {get(data, control.dataKey ?? '', '')}
      </Typography>
    )
  }

  const className = `eform-text-${currentMode === 'view'? 'readonly-' : ''}${theme.palette.mode}`;

  return (
    <>
      {errorMessage ? (
        <FormControl variant="standard" style={textStyle} error><TextareaAutosize
          minRows={3}
          className={className}
          style={textStyle}
          name={control.name}
          value={selectedValue}
          placeholder={textAreaControl.placeholder}
          onChange={(e) => handleFieldChange(control.dataKey ?? '', e.target.value)}
          readOnly={currentMode === 'view'}
          spellCheck={true}
        /><FormHelperText>{errorMessage}</FormHelperText></FormControl>
      ) : (
        <TextareaAutosize
          minRows={3}
          className={className}
          style={textStyle}
          name={control.name}
          value={selectedValue}
          placeholder={textAreaControl.placeholder}
          onChange={(e) => handleFieldChange(control.dataKey ?? '', e.target.value)}
          readOnly={currentMode === 'view'}
          spellCheck={true}
        />
      )}
    </>
  );
};

export default TextAreaControl;
